// Identificador aleatório opaco, para uso do front (token do alerta de login,
// id do visitante). Hex puro, sem hífen: entra em cookie e em corpo de POST
// sem escape.
//
// A ordem dos degraus não é a intuitiva. `crypto.randomUUID` é o nome que todo
// mundo lembra, mas ele **só existe em contexto seguro** (https ou localhost):
// numa página http pura vem `undefined` e a chamada derrubaria quem depende
// dele. `crypto.getRandomValues` não tem essa restrição, então vem primeiro.
// O último degrau não é criptográfico e existe só para não deixar o chamador
// sem id nenhum — aqui um id serve para agrupar mensagens, não para autenticar.
export function randomId(bytes = 16) {
  const c = typeof crypto !== "undefined" ? crypto : null;

  if (c && typeof c.getRandomValues === "function") {
    const buf = c.getRandomValues(new Uint8Array(bytes));
    return Array.from(buf, (b) => b.toString(16).padStart(2, "0")).join("");
  }

  if (c && typeof c.randomUUID === "function") return c.randomUUID().replace(/-/g, "");

  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2, 10)}`;
}

export default randomId;
